import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';

const styles = theme => ({
    formControl: {
        margin: theme.spacing(1)
    },
    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    }
});

class DepannageDirectClient extends React.Component {
    render() {
        const { classes, onDetailChange, value } = this.props;
        
        return (<FormControl component="fieldset" className={classes.formControl} required>
            <FormLabel component="legend">Avez-vous résolu le problème de votre client ?</FormLabel>
            <RadioGroup
                name="DEPANNAGE_DIRECT_CLIENT"
                className={classes.group}
                value={value}
                onChange={onDetailChange}
            >
                <FormControlLabel className={classes.heightLabel} value="true" control={<Radio />} label="Oui" />
                <FormControlLabel className={classes.heightLabel} value="false" control={<Radio />} label="Non" />
            </RadioGroup>
        </FormControl>
        );
    }
}

DepannageDirectClient.propTypes = {
    onDetailChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired
};

export default withStyles(styles)(DepannageDirectClient);